import Lenis from "lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis();

lenis.on('scroll', ScrollTrigger.update);
window.addEventListener('resize', ScrollTrigger.update)

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);
// let mm = gsap.matchMedia();

// Marquee
const marquees = document.querySelectorAll('.marquee');

if (marquees.length) {
  marquees.forEach((marquee) => {
    const group = marquee.querySelector('.group');
    const groupWidth = group.getBoundingClientRect().width;

    const duration = Math.floor(groupWidth / 200);
  
    gsap.to(marquee, {
      x: -groupWidth,
      duration: duration,
      ease: 'linear',
      repeat: -1,
    });
  })
}

// Blur in
const blurEls = document.querySelectorAll('[animate-blur-in], .animate-blur-in');

blurEls.forEach(el => {
  gsap.from(el, {
    filter: 'blur(10px)',
    opacity: 0,
    duration: 1,
    delay: 0.2,
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
    }
  })
})